import React, {PureComponent} from "react";
import {connect} from "react-redux";

class Preloader extends PureComponent {

    render() {
        const {isShow} = this.props;

        if (!isShow) return null;

        return <div className="preloader__container">
            <div className="preloader__spinner">
                <div className="preloader__spinner-dot"/>
                <div className="preloader__spinner-dot"/>
                <div className="preloader__spinner-dot"/>
                <div className="preloader__spinner-dot"/>
                <div className="preloader__spinner-dot"/>
                <div className="preloader__spinner-dot"/>
            </div>
        </div>;
    }
}

export default connect(
    state => ({
        isShow: state.preloader.isShow,
    }),
)(Preloader)